export default __webpack_public_path__ + "images/ae69481070e6e6880dcc974e14240efc-greeting-card.svg";